"use client";

import { useEffect } from "react";

type ProfitWellCommand = ((...args: unknown[]) => void) & { q?: unknown[][] };
type ProfitWellWindow = Window & {
  profitwell?: ProfitWellCommand;
  profitwellScriptLoaded?: boolean;
  profitwellFired?: boolean;
};

export default function ProfitWellIntegration() {
  useEffect(() => {
    const profitWellWindow = window as ProfitWellWindow;
    if (!profitWellWindow.profitwell) {
      const queue: ProfitWellCommand = (...args) => {
        (queue.q ??= []).push(args);
      };
      profitWellWindow.profitwell = queue;
    }

    if (!profitWellWindow.profitwellScriptLoaded) {
      const existing = document.querySelector(
        'script[src^="https://public.profitwell.com/js/profitwell.js"]',
      );
      if (!existing) {
        const script = document.createElement("script");
        script.id = "profitwell-js";
        script.async = true;
        script.dataset.pwAuth = "8071fa85e8a78dd829e5f6897cc84946";
        script.src = `https://public.profitwell.com/js/profitwell.js?auth=${script.dataset.pwAuth}`;
        document.body.appendChild(script);
      }
      profitWellWindow.profitwellScriptLoaded = true;
    }

    if (!profitWellWindow.profitwellFired) {
      profitWellWindow.profitwellFired = true;
      profitWellWindow.profitwell("start", {});
    }
  }, []);

  return null;
}
